import React, { Component } from 'react';
import styles from './UserProfile.module.css';
import {connect} from 'react-redux';
import axios from 'axios';
import loader from '../../assets/loader.svg';
import loader2 from '../../assets/loader2.svg';
import privateIcon from '../../assets/private.png';
import suspendedIcon from '../../assets/Suspended.png';
import checkedUserIcon from '../../assets/checked_user.png';
import Modal from '../../components/ConfirmModal/Modal';
import FollowList from '../Modal/FollowList/FollowList';
import PictureFrame from '../Modal/PictureFrame/PictureFrame';
import { Link } from 'react-router-dom';
import firebase from 'firebase';

class UserProfile extends Component {
    
    state = {
        user: {},
        users:{},
        userId: '',
        followClicked: false,
        following: false,
        requested: false,
        modal: {
            isModalOpen: false,
            userId: '',
            name: '',
            profilePic: '',
            clicked: false
        },
        followListModal: {
            isShow: false,
            name: '',
            followList: [],
            followClicked: [],
            following: [],
        },
        pictureFrame: {
            isModalOpen: false,
            post:{}
        }
    }

    componentDidMount() {
        const userId = this.props.match.params.userId;
        let loginStatus = this.props.loginStatus;
        if(userId === loginStatus.userId) {
            this.props.history.replace({pathname: '/profile'});
        }
      
        firebase.database().ref('users/' + userId).on('value', (snapShot)=>{
            this.setState({
                user: snapShot.val(),
                following: snapShot.val().followers.indexOf(loginStatus.userId) !== -1,
                requested: snapShot.val().requests.indexOf(loginStatus.userId) !== -1
            });
        });

        axios.get('/users/'+ 
        loginStatus.userId + '/following.json?auth=' + loginStatus.authToken)
        .then(response => {
                this.setState({
                    followListModal: {
                        ...this.state.followListModal,
                        following: response.data
                    }
                })
        });

        axios.get('/users.json?auth='+ this.props.loginStatus.authToken)
        .then(response=>{
            this.setState({users: response.data});
        })
    }

    componentDidUpdate() {
        if(!this.props.loginStatus.isLoggedIn) {
            this.props.history.replace({pathname: '/'});
        }
        const userId = this.props.match.params.userId;
        if(this.state.userId !== userId) {
            this.setState({userId: userId});
            let loginStatus = this.props.loginStatus;
            if(userId === loginStatus.userId) {
                this.props.history.replace({pathname: '/profile'});
            }
            axios.get('/users/'+ 
            userId + '.json?auth=' + loginStatus.authToken)
            .then(response => {
                this.setState({
                    user: response.data,
                    following: response.data.followers.indexOf(loginStatus.userId) !== -1,
                    requested: response.data.requests.indexOf(loginStatus.userId) !== -1
                });
            });
            axios.get('/users/'+ 
            loginStatus.userId + '/following.json?auth=' + loginStatus.authToken)
            .then(response => {
                    this.setState({
                        followListModal: {
                            ...this.state.followListModal,
                            isShow: false,
                            following: response.data
                        }
                    })
            });
        }
        
        
    }

  
    toggleDropdown(event) {
        event.target.classList.toggle(styles.dropdownOpen);
    }

    followRequest = () => {
        const userId = this.props.match.params.userId;
        const loggedInUserId = this.props.loginStatus.userId;
        axios.get('/users/' + userId + '.json?auth=' + 
        this.props.loginStatus.authToken)
         .then(response => {
             const userData = response.data;
             if(userData.requests.indexOf(loggedInUserId) !== -1) return;
             userData.requests.push(loggedInUserId);
             userData.notifications.map((obj, index) => {
                if(obj.userId === loggedInUserId && obj.key === 'REQUEST') {
                    userData.notifications.splice(index, 1);
                }
            })
            userData.notifications.push({
                key: 'REQUEST',
                name: this.props.userData.name,
                isRead: false,
                profilePic: this.props.userData.profilePic,
                timeStamp: new Date(),
                userId: loggedInUserId
            });
            axios.put('/users/' + userId + '.json?auth=' + 
            this.props.loginStatus.authToken, userData)
            .catch(err=>console.log(err));

            axios.get('/users/'+ loggedInUserId +'/sentRequest.json?auth='+ 
            this.props.loginStatus.authToken)
            .then(response2 => {
                const sentRequests = response2.data;
                sentRequests.push(userId);
                axios.put('/users/'+ loggedInUserId +'/sentRequest.json?auth='+ 
                this.props.loginStatus.authToken, sentRequests)
                .then(() => {
                    this.setState({
                        followClicked: false,
                        requested: true
                    });
              
           })
           .catch(error=>console.log(error));
       })
         })
         .catch(err=>console.log(err));
    }

    cancelRequest = () => {
        const userId = this.props.match.params.userId;
        const loggedInUserId = this.props.loginStatus.userId;
        this.setState({followClicked: true});
        axios.get('/users/' + userId + '.json?auth=' + 
        this.props.loginStatus.authToken)
         .then(response => {
             const userData = response.data;
             userData.requests.splice(userData.requests.indexOf(loggedInUserId), 1);
             userData.notifications.map((obj, index) => {
                 if(obj.userId === loggedInUserId && obj.key === 'REQUEST') {
                     userData.notifications.splice(index, 1);
                 }
             })
            axios.put('/users/' + userId + '.json?auth=' + 
            this.props.loginStatus.authToken, userData)
            .catch(err=>console.log(err));

            axios.get('/users/'+ loggedInUserId +'/sentRequest.json?auth='+ 
            this.props.loginStatus.authToken)
            .then(response2 => {
                const sentRequests = response2.data;
                sentRequests.splice(sentRequests.indexOf(userId), 1);
                axios.put('/users/'+ loggedInUserId +'/sentRequest.json?auth='+ 
                this.props.loginStatus.authToken, sentRequests)
                .then(() => {
                    this.setState( {
                        followClicked: false,
                        requested: false
                    })              
           })
           .catch(error=>console.log(error));
       })
            
         })
         .catch(err=>console.log(err));
    }

    follow = (id) => {
       const userId = id !== undefined ? id : this.props.match.params.userId;
       const loggedInUserId = this.props.loginStatus.userId;
       this.setState((prevState) => {
          if(prevState.followClicked || prevState.followListModal.followClicked.indexOf(userId) !== -1) return;
          if(id) {
              return {
                  followListModal: {
                      ...this.state.followListModal,
                      followClicked: [...this.state.followListModal.followClicked, userId]
                  }
              }
          }
          return {followClicked: true};
       });
            
       axios.get('/users/'+ userId +'.json?auth='+ 
       this.props.loginStatus.authToken)
        .then(response=>{
            const userData = response.data;
            if(userData.followers.indexOf(loggedInUserId) !== -1) return;
            if(userData.isAccountPrivate) {
                this.followRequest();
                return;
            }
            userData.followers.push(loggedInUserId);
            userData.notifications.map((obj, index) => {
                if(obj.userId === loggedInUserId && obj.key === 'FOLLOW'){
                    userData.notifications.splice(index, 1);
                }
            })
            userData.notifications.push({
                key: 'FOLLOW',
                name: this.props.userData.name,
                isRead: false,
                profilePic: this.props.userData.profilePic,
                timeStamp: new Date(),
                userId: this.props.loginStatus.userId
            })
            userData.notifications = userData.notifications.slice(-10);
            axios.put('/users/'+ userId +'.json?auth='+ 
            this.props.loginStatus.authToken, userData)
            .catch(error=>console.log(error));

            axios.get('/users/'+ loggedInUserId +'/following.json?auth='+ 
            this.props.loginStatus.authToken)
            .then(response2 => {
                const loggedInUserFollowing = response2.data;
                loggedInUserFollowing.push(userId);
                axios.put('/users/'+ loggedInUserId +'/following.json?auth='+ 
                this.props.loginStatus.authToken, loggedInUserFollowing)
                .then((res) => {
                    this.setState((prevState)=>{ 
                        if(id) {
                            const array = [...prevState.followListModal.followClicked];
                            array.splice(array.indexOf(userId), 1)
                            return {
                                followListModal: {
                                    ...prevState.followListModal,
                                    followClicked: array,
                                    following: res.data
                                }
                            }
                        } 
                        return  {
                            following: true,
                            followClicked: false,
                            user: {
                                ...prevState.user,
                                    followers: userData.followers
                            }
                        
                        }
                      
                    });
                })
                .catch(error=>console.log(error))
            })
        })
        .catch(err=>console.log(err));
    }

    unfollow = () => {
        this.setState({
            modal: {
                ...this.state.modal,
                clicked: true
            }
        });
        const userId = this.state.modal.userId;
        const loggedInUserId = this.props.loginStatus.userId;
    
       axios.get('/users/'+ userId +'/followers.json?auth='+ 
       this.props.loginStatus.authToken)
        .then(response=>{
            const userFollowers = response.data;
            if(userFollowers.indexOf(loggedInUserId) === -1) return;
            userFollowers.splice(userFollowers.indexOf(loggedInUserId), 1);
            axios.put('/users/'+ userId +'/followers.json?auth='+ 
            this.props.loginStatus.authToken, userFollowers)
            .catch(error=>console.log(error));

            axios.get('/users/'+ loggedInUserId +'/following.json?auth='+ 
            this.props.loginStatus.authToken)
            .then(response2 => {
                const loggedInUserFollowing = response2.data;
                if(loggedInUserFollowing.indexOf(userId) === -1) return;
                loggedInUserFollowing.splice(loggedInUserFollowing.indexOf(userId), 1);
                axios.put('/users/'+ loggedInUserId +'/following.json?auth='+ 
                this.props.loginStatus.authToken, loggedInUserFollowing)
                .then((res) => {
                    this.closeModal();
                    this.setState((prevState) => {
                        if(this.state.followListModal.isShow) {
                            return {
                                followListModal: {
                                    ...this.state.followListModal,
                                    following: res.data
                                }
                            }
                        }
                        return {
                        following: false,
                        user: {
                            ...prevState.user,
                              followers: userFollowers
                              }
                         }
                    });
                    
                })
            })
            .catch(error=>console.log(error));

        })
    }
    closeModal = () => {
        this.setState({
            modal: {
                ...this.state.modal,
                isModalOpen: false,
                clicked: false
            }
        });
    }

    followingClickHandler = (userId, name, profilePic) => {
        this.setState({
            modal: {
                isModalOpen: true,
                userId: userId,
                message: `Unfollow ${name} ?`,
                imageUrl: profilePic,
                action: 'Unfollow',
                confirm: this.unfollow
            }
        })
    }

    toggleFollowListModal = (name) => {
        this.setState({
            followListModal: {
                ...this.state.followListModal,
                isShow: !this.state.followListModal.isShow,
                name: name,
                followList: this.state.user[name.toLowerCase()]
            }
        })
    }
    togglePictureFrame = (event) => {
        const modal = {...this.state.pictureFrame};
        modal.isModalOpen = !this.state.pictureFrame.isModalOpen;
        modal.post = this.state.user.posts[+event.target.id];
        if(event.target.id) {
            modal.post.userId = this.props.match.params.userId;
            modal.post.index = +event.target.id;
        }
       
        this.setState({pictureFrame: modal});
    }
    getPosts = () => {
        const row = [];
        const userPosts = this.state.user.posts;
        let index = userPosts.length - 1;
        for(let i = 0; i< Math.ceil((userPosts.length - 1) / 3); i++) {
            const column = [];
            for(let j = 0; j < 3; j++) {
                if(index === 0) break;
                column.push(
                    <div key={index} className={styles.column}>
                        <img src={userPosts[index].url} alt="post"/>
                        <div className={styles.cover} id={index} onClick={this.togglePictureFrame} ></div>
                    </div>
                )
                index --;
            }
        row.push(<div key={i} className={styles.row}>{column}</div>);
        }
        return row;
    }

    getBio = (text) => {
        var Rexp = /((http|https|ftp):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g; 
        const links = [...text.matchAll(Rexp)];
        links.map(link=> {
            text = text.replace(link[0], '<a href='+link[0] +' style="color:#0065c8">'+link[0]+'</a>');
        });
        return text.replace(/\n/g,'<br />');
    }
    render() {

        let profile = null;
        if(Object.keys(this.state.user).length !== 0) {
            const user = this.state.user;
          profile = (
            <div className={styles.top}>
               <div className={styles.header}>
                  <div className={styles.dp}>
                    <img src={user.profilePic} 
                        alt="profile pic" />
                    <div className={styles.cover}></div>
                  </div>
                  <div style={{width:'77%'}}>
                    <div className={styles.name}>
                      <div>
                        <h2>{user.name}</h2>
                        {user.isVerified ?
                         <span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20">
                            <polygon fill="#42a5f5" points="29.62,3 33.053,8.308 39.367,8.624 39.686,14.937 44.997,
                            18.367 42.116,23.995 45,29.62 39.692,33.053 39.376,39.367 33.063,39.686 29.633,44.997 24.005,
                            42.116 18.38,45 14.947,39.692 8.633,39.376 8.314,33.063 3.003,29.633 5.884,24.005 3,18.38 8.308,
                            14.947 8.624,8.633 14.937,8.314 18.367,3.003 23.995,5.884"/>
                            <polygon fill="#fff" points="21.396,31.255 14.899,24.76 17.021,22.639 21.428,27.046 30.996,
                            17.772 33.084,19.926"/>
                            </svg>
                          </span>
                          : null
                        }
                      
                      </div>
                      <div className={styles.action}>
                     
                      {!this.state.following ?
                        (!this.state.requested ?
                            <div><button className={styles.follow} onClick={()=>this.follow()}>
                            {!this.state.followClicked ?
                            'Follow' :
                            <img src={loader2} alt="loader" width="18" height="18" style={{marginTop: '5px'}} />
                            } 
                        </button> </div>
                            :
                       <div> <button className={styles.request} onClick={()=>this.cancelRequest()}>
                            {!this.state.followClicked ?
                            'Requested' :
                            <img src={loader2} alt="loader" width="18" height="18" style={{marginTop: '5px'}} />
                            } 
                        </button></div>
                        )
                        :
                       <div className={styles.inlineDiv}> <button className={styles.following}
                        onClick={()=>this.followingClickHandler(this.props.match.params.userId, user.name, user.profilePic)}>
                            <img src={checkedUserIcon} alt="following icon" width="20" height="20" />
                        </button> </div>
                        }
                     
                      <div className={styles.inlineDiv}>
                        {this.state.following ?
                        <Link to={'/messages/' + this.props.match.params.userId} className={styles.message}>
                            Message
                        </Link> : null
                        }
                      </div>
                      </div>
                    </div>
                    <div className={styles.accDetails}>
                      <ul>
                        <li>
                            <span>
                                <span className={styles.count}>{user.posts.length-1}</span> Posts
                            </span>
                        </li>
                        <li>
                            <span onClick={()=>this.toggleFollowListModal('Followers')} style={{cursor: 'pointer'}}>
                                <span className={styles.count}>{user.followers.length-1}</span> Followers
                            </span>
                        </li>
                        <li>
                            <span onClick={()=>this.toggleFollowListModal('Following')} style={{cursor: 'pointer'}}>
                                <span className={styles.count}>{user.following.length-1}</span> Following
                            </span>
                        </li>
                      </ul>
                    </div>
                    <div className={styles.bio}>
                        <p dangerouslySetInnerHTML={user.bio !== 'NA' ?{__html: this.getBio(user.bio)}:null}>
                        </p>
                    </div>
                 </div>
                </div>
                <div className={styles.body}>
                    
                    {user.isAccountPrivate && user.followers.indexOf(this.props.loginStatus.userId) < 0 ?
                     <div className={styles.private}>
                         <img src={privateIcon} alt="private account" width="50" />
                         <h2> This Account is Private</h2>
                         <p>Follow this account to see their photos</p>
                     </div> : 
                      <div className={styles.posts}>
                        {this.getPosts()}
                      </div>
                    }
                    {(!user.isAccountPrivate || user.isAccountPrivate && user.followers.indexOf(this.props.loginStatus.userId) > -1) && this.state.user.posts.length < 2 ?
                        <div className={styles.noPost}>
                            No Post Available
                        </div> : null
                    }                  
                </div>
            </div>
            ); 
        } else {
            profile = (
                <div className={styles.top}>
                <div style={{marginTop:'25%'}}>
                    <img src={loader} alt="loading"/>
                </div>
                </div>
            )
        }
    return(
      <div className={styles.profile}>
          <section>
            {this.state.user.account_status ==='DISABLED'?
            <div className={styles.suspended}>
               <h2> This Account is currently Suspended </h2>
               <img src={suspendedIcon} alt="suspended" />
            </div>
             : profile
            }
         </section>
         {this.state.modal.isModalOpen ?
            <Modal {...this.state.modal} closeModal={this.closeModal}/>
            : null
         }

        {this.state.followListModal.isShow ?
          <FollowList data={this.state.followListModal}
           close={()=>this.toggleFollowListModal(this.state.followListModal.name)}
           follow={this.follow} followingClickHandler={this.followingClickHandler}/>
          :null
        }
        {this.state.pictureFrame.isModalOpen ? 
        <PictureFrame {...this.state.pictureFrame.post} user={this.state.user} 
            users={this.state.users} close={this.togglePictureFrame}/> : null
        }
    </div>  
    )
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus,
        userData: state.userData
    }
}
export default connect(mapStateToProps)(UserProfile);